import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  obj2vqjd1bjrpmyg as obj,
  nullable1in0t8o94jx9t as nullable,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import {
  Datarsj944sbse7g as Data,
  BeginDiscordOAuth3el1thryt54ev as BeginDiscordOAuth,
} from '../BeginDiscordOAuthMutation.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { missingField4n9ldh7pi82p as missingField } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Assertions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.k6m_1 = listOf('beginDiscordOAuth');
      }
      p40(reader, customScalarAdapters) {
        var _beginDiscordOAuth = null;
        $l$loop: while (true) {
          if (reader.n4f(this.k6m_1) === 0)
            _beginDiscordOAuth = nullable(obj(BeginDiscordOAuth_getInstance())).p40(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_beginDiscordOAuth);
      }
      l6m(writer, customScalarAdapters, value) {
        writer.l4d('beginDiscordOAuth');
        nullable(obj(BeginDiscordOAuth_getInstance())).u40(writer, customScalarAdapters, value.f6g_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.l6m(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
var BeginDiscordOAuthClass;
function BeginDiscordOAuth_0() {
  if (BeginDiscordOAuthClass === VOID) {
    class $ {
      constructor() {
        BeginDiscordOAuth_instance = this;
        this.m6m_1 = listOf_0(['state', 'expiresAt']);
      }
      p40(reader, customScalarAdapters) {
        var _state = null;
        var _expiresAt = null;
        $l$loop: while (true) {
          switch (reader.n4f(this.m6m_1)) {
            case 0:
              _state = get_StringAdapter().p40(reader, customScalarAdapters);
              break;
            case 1:
              _expiresAt = get_StringAdapter().p40(reader, customScalarAdapters);
              break;
            default:
              break $l$loop;
          }
        }
        var tmp1_elvis_lhs = _state;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          missingField(reader, 'state');
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp_0 = tmp;
        var tmp2_elvis_lhs = _expiresAt;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          missingField(reader, 'expiresAt');
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        return new (BeginDiscordOAuth())(tmp_0, tmp_1);
      }
      n6m(writer, customScalarAdapters, value) {
        writer.l4d('state');
        get_StringAdapter().q40(writer, customScalarAdapters, value.g6g_1);
        writer.l4d('expiresAt');
        get_StringAdapter().q40(writer, customScalarAdapters, value.h6g_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.n6m(writer, customScalarAdapters, value instanceof BeginDiscordOAuth() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'BeginDiscordOAuth', VOID, VOID, [Adapter()]);
    BeginDiscordOAuthClass = $;
  }
  return BeginDiscordOAuthClass;
}
var BeginDiscordOAuth_instance;
function BeginDiscordOAuth_getInstance() {
  if (BeginDiscordOAuth_instance === VOID)
    new (BeginDiscordOAuth_0())();
  return BeginDiscordOAuth_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance1kmwiv1j3ytfz,
};
//endregion

//# sourceMappingURL=BeginDiscordOAuthMutation_ResponseAdapter.mjs.map
